import {
  ACCESS_COOKIE_NAME,
  ACCESS_TOKEN,
  AIM_OIDC_CLIENT_ID,
  AIM_OIDC_LOGOUT_ENDPOINT,
  CORRELATION_ID,
  PEQUITY_API_URL,
  PEQUITY_BASE_URL,
  PEQUITY_SOCKET_PROTOCOL,
  PEQUITY_SOCKETS_BASE_URL,
  REFRESH_TOKEN,
} from '@/types';

export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;
const isFeatureTest = !!window.localStorage.getItem('TestServerSubdomain');

// XXX This should be in the .env file.
export const getUrlBase = () => {
  const protocol = window.location.protocol + '//';
  const split = window.location.host.split(':');
  const newHost = split.length > 1 ? split[0] + ':8000' : split[0];
  return protocol + newHost;
};

export const URL_BASE = getUrlBase();
export const TENANT =
  window.location.hostname === PEQUITY_BASE_URL.split(':')[0] ? null : window.location.hostname.split('.')[0];

const getApiUrl = () => {
  const url = new URL(PEQUITY_API_URL);
  // For test environment we need to use a different port and subdomain
  url.host = TENANT
    ? `${isFeatureTest ? window.localStorage.getItem('TestServerSubdomain') : TENANT}.${url.host}`
    : url.host;

  if (isFeatureTest) {
    url.port = `${window.localStorage.getItem('TestServerPort')}`;
  }

  return url.href;
};

export const API_URL = getApiUrl();

const wsSubdomain = TENANT ? `${TENANT}.` : '';
export const WEBSOCKETS_URL = isFeatureTest
  ? `${PEQUITY_SOCKET_PROTOCOL}://${wsSubdomain}${PEQUITY_SOCKETS_BASE_URL.split(':')[0]}:${window.localStorage.getItem('TestServerDaphnePort')}/ws`
  : `${PEQUITY_SOCKET_PROTOCOL}://${wsSubdomain}${PEQUITY_SOCKETS_BASE_URL}/ws`;

// Token helpers
export const tokenExpired = (token: string) => {
  if (!token) {
    return true;
  }
  const msExpiration = JSON.parse(atob(token.split('.')[1])).exp;
  const adjustedExpiration = msExpiration * 1000 - 15000;
  return adjustedExpiration < Date.now();
};

const setAccessCookie = (cookie: string) => {
  document.cookie = `${ACCESS_COOKIE_NAME}=${cookie}; path=/;`;
};

const IS_OIDC_SESSION = 'is_oidc_session';

export const setIsOidcSession = () => localStorage.setItem(IS_OIDC_SESSION, 'true');
const clearIsOidcSession = () => localStorage.removeItem(IS_OIDC_SESSION);
export const isOidcSession = () => localStorage.getItem(IS_OIDC_SESSION) === 'true';

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  setAccessCookie('');
  localStorage.removeItem(REFRESH_TOKEN);
  clearIsOidcSession();
};

export const submitAimLogoutForm = (accessToken: string) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = AIM_OIDC_LOGOUT_ENDPOINT;

  const fields: Record<string, string> = {
    token_type_hint: 'access_token',
    token: accessToken,
    post_logout_redirect_uri: `${window.location.origin}/v2/logged-out`,
    trans_id: 'pequity-oidc',
    client_id: AIM_OIDC_CLIENT_ID,
  };

  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
};

export const setAccessToken = (token: string) => {
  localStorage.setItem(ACCESS_TOKEN, token);
  setAccessCookie(`Bearer ${token}`);
};

export const setRefreshToken = (token: string) => {
  localStorage.setItem(REFRESH_TOKEN, token);
};

// Correlation Id helpers
export const setCorrelationId = (id: string | null) => {
  if (id === null) {
    return removeCorrelationId();
  }

  localStorage.setItem(CORRELATION_ID, id);
};

export const removeCorrelationId = () => {
  localStorage.removeItem(CORRELATION_ID);
};

export const getCorrelationId = () => {
  return localStorage.getItem(CORRELATION_ID) || null;
};
